<!-- 收费投诉管理 -->
<template>
<div>
    <div class="index" v-if="!detail.show">
        <div class="title">
            <div class="span1">
                <span>{{$route.name}}</span>
            </div>
        </div>

        <div>
			<el-form :inline="true" :model="queryParams" label-width="70px">
				<el-form-item label="学期学年">
                    <el-select v-model="queryParams.semester" clearable placeholder="选择学年学期" class="label">
                        <el-option v-for="item in semesterList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="处理进度">
                    <el-select v-model="queryParams.cl" clearable placeholder="选择处理进度" class="label">
                        <el-option v-for="item in clList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="投诉日期">
					<el-date-picker v-model="queryParams.date" type="daterange" style="width: 240px;" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" >
					</el-date-picker>
				</el-form-item>
				<el-form-item label="投诉订单号" label-width="90px">
                    <el-input v-model="queryParams.num" placeholder="请输入订单号"></el-input>
                </el-form-item>
				 <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
                </el-form-item>
			</el-form>

            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="a" label="投诉编号" align="center">
                    </el-table-column>
                    <el-table-column prop="b" label="投诉时间" align="center">
                    </el-table-column>
                    <el-table-column prop="c" label="投诉订单号" align="center">
                    </el-table-column>
                    <el-table-column prop="d" label="处理进度" align="center">
						<template slot-scope="scope">
							<p :style="{color:scope.row.d==='处理中'?'#D9001B':'#70B603'}">{{scope.row.d}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column header-align="center" align="center" label="操作" width="200" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="toDetail(scope.row)">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
    <Detail :info.sync="detail.info" v-show="detail.show" @to-index="toIndex"></Detail>
</div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
export default {
    components:{
        Detail: ()=>import('./detail.vue')
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				semester: '',
				cl:'',
				date:'',
				num:'',
			},
			clList:[
				{id:'cl1',label:'处理中'},
				{id:'cl2',label:'已处理'},
			],
			semesterList: [
				{id:'xq1',label:'2021~2022年度下学期'},
				{id:'xq2',label:'2021~2022年度上学期'},
				{id:'xq3',label:'2020~2021年度下学期'},
				{id:'xq4',label:'2020~2021年度上学期'},
				{id:'xq5',label:'2019~2020年度下学期'},
				{id:'xq6',label:'2019~2020年度上学期'},
			],
			tableData: [
				// {a:'258141641',b:'2021/11/23 17:56:22',c:'79277670',d:'处理中',},
				// {a:'277068740',b:'2021/10/23 17:50:22',c:'47710836',d:'已处理',},
				// {a:'284806082',b:'2021/10/25 13:40:22',c:'71063119',d:'处理中',},
				// {a:'281021428',b:'2021/10/23 11:56:22',c:'77983690',d:'已处理',},
				// {a:'288109311',b:'2021/10/15 10:56:22',c:'72941330',d:'处理中',},
				// {a:'262617944',b:'2021/09/12 09:56:22',c:'66473167',d:'已处理',},
				// {a:'259587779',b:'2021/09/12 08:56:22',c:'56109184',d:'处理中',},
				// {a:'245431053',b:'2021/09/13 12:56:22',c:'55538843',d:'处理中',},
				// {a:'246029828',b:'2021/09/03 14:56:22',c:'73655046',d:'处理中',},
			],
            detail:{
                info:{},
                show:false,
            },
			school_info:JSON.parse(sessionStorage.getItem('classList')),
			semesterArr:JSON.parse(sessionStorage.getItem('semesterList')),
		}
	},
	watch:{

	},
	created() {
		// this.getDataList();
	},
	methods: {
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem('orgId'),
				platformCode:sessionStorage.getItem('platformCode'),
				schoolYearSemester:this.queryParams.semester,
				campusId:this.queryParams.campus,
				classId:this.queryParams.class,
				gradeId:this.queryParams.grade,
				page:this.pageNum,
				limit:this.pageSize,
			}
			// let res = await api.studentClassStatistics(params);
			// if(res.code==='0'){
			// 	this.tableData=res.data?.list || [];
			// 	this.totalPage=res.data?.total || 0;
			// }
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        toDetail(item){
			this.detail.info=item;
            this.detail.show=true;
        },
        toIndex(){
            this.detail.show=false;
        },
	},
	mounted() {
		// this.semesterList=this.semesterArr.map(v=>({label:v.schoolYear+'第'+v.semester+'学期',id:v.schoolYear+'_'+v.semester}))
	},
}
</script>
<style lang="less" scoped>
.index {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
			margin-right: 30px;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 150px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
</style>
